import { useApiClient } from '@startupquickstart/frontend';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

interface GenerateVoiceoversParams {
  attractionId: string;
  themeId: string;
  voiceoverType: 'both' | 'description' | 'long_description';
  voice: 'alloy' | 'echo' | 'fable' | 'onyx' | 'nova' | 'shimmer';
}

/**
 * Hook for generating AI voiceovers for an attraction theme
 */
export function useGenerateThemeVoiceovers() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      attractionId,
      themeId,
      voiceoverType,
      voice,
    }: GenerateVoiceoversParams) => {
      return apiClient.post(
        `/attractions/${attractionId}/themes/${themeId}/generate-voiceovers`,
        { voiceoverType, voice },
      );
    },
    onSuccess: (_data, variables) => {
      // Invalidate queries to refresh the theme data
      queryClient.invalidateQueries({
        queryKey: ['AttractionTheme', variables.attractionId],
      });
      toast.success('Voiceovers generated successfully');
    },
    onError: (error: Error) => {
      toast.error(error?.message || 'Failed to generate voiceovers');
    },
  });
}
